const enum EOperator  {
    Vodafone = "Vodafone",
    Kyivstar = "Kyivstar",
    lifecell = "Lifecell"
}

export {EOperator}